import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import { useEffect } from "react";
// import { Popover } from "@mui/material";

export default function UIPopper({
  children,
  clickNode,
  onClose,
  style,
  closePopover,
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "right",
  },
  sx = {},
  paperClasses = "custom-scroll",
  onHover = false,
  id = "simple-popover",
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    console.log("closed");
    setAnchorEl(null);
    if (onClose) onClose();
  };

  useEffect(() => {
    if (closePopover) {
      setAnchorEl(null);
    }
  }, [closePopover]);

  const open = Boolean(anchorEl);
  const compId = open ? id : undefined;
  return (
    <>
      {React.cloneElement(clickNode, {
        ...(onHover
          ? { onMouseEnter: handleClick, onMouseLeave: handleClose }
          : { onClick: handleClick }),
      })}
      <Popover
        sx={sx}
        id={compId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        PaperProps={{ sx: style }}
        classes={{
          paper: paperClasses,
        }}
      >
        {typeof children == "function" ? children({ setAnchorEl }) : children}
      </Popover>
    </>
  );
}
